import { useUserStore } from '@/stores/user'

export const authenticate = (login: string, password: string) => {
  const userStore = useUserStore()

  return new Promise((resolve, reject) => {
    const apiUrl =
      import.meta.env.VITE_USE_MOCKS !== 'true'
        ? `${import.meta.env.VITE_API_URL}/authentication`
        : new URL(`/src/mocks/get/authentication.json`, import.meta.url).href

    const data = {
      login: login,
      password: password,
    }
    const options = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }

    fetch(apiUrl, options)
      .then((response) => {
        if (response.ok) {
          return response.json()
        } else {
          throw new Error(`Échec de l'authentification`)
        }
      })
      .then((data) => {
        if (data.token) {
          userStore.login(data)
          resolve(true)
        } else {
          throw new Error(`Échec de l'authentification`)
        }
      })
      .catch((error) => {
        reject(error)
      })
  })
}
